export default "/corgi/pageapps/prepurchase/_next/static/media/arrow-left.e9735d79.svg";